/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Apply_A_To_B_TitleInputs */

const en_compare_event_groups_apply_a_to_b_title = /** @type {(inputs: Compare_Event_Groups_Apply_A_To_B_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply changes from Group A to Group B`)
};

const fr_compare_event_groups_apply_a_to_b_title = /** @type {(inputs: Compare_Event_Groups_Apply_A_To_B_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appliquer les modifications du groupe A au groupe B`)
};

const de_compare_event_groups_apply_a_to_b_title = /** @type {(inputs: Compare_Event_Groups_Apply_A_To_B_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen von Gruppe A auf Gruppe B übertragen`)
};

const it_compare_event_groups_apply_a_to_b_title = /** @type {(inputs: Compare_Event_Groups_Apply_A_To_B_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applica le modifiche dal Gruppo A al Gruppo B`)
};

const ru_compare_event_groups_apply_a_to_b_title = /** @type {(inputs: Compare_Event_Groups_Apply_A_To_B_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перенесите изменения из группы А в группу В.`)
};

const es_compare_event_groups_apply_a_to_b_title = /** @type {(inputs: Compare_Event_Groups_Apply_A_To_B_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar cambios del Grupo A al Grupo B`)
};

const zh_cn2_compare_event_groups_apply_a_to_b_title = /** @type {(inputs: Compare_Event_Groups_Apply_A_To_B_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将A组的变更应用到B组。`)
};

const ja_compare_event_groups_apply_a_to_b_title = /** @type {(inputs: Compare_Event_Groups_Apply_A_To_B_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループAからグループBへの変更を適用する`)
};

const hi_compare_event_groups_apply_a_to_b_title = /** @type {(inputs: Compare_Event_Groups_Apply_A_To_B_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूह A से समूह B में परिवर्तन लागू करें`)
};

const pt_pt2_compare_event_groups_apply_a_to_b_title = /** @type {(inputs: Compare_Event_Groups_Apply_A_To_B_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar as alterações do Grupo A ao Grupo B.`)
};

/**
* | output |
* | --- |
* | "Apply changes from Group A to Group B" |
*
* @param {Compare_Event_Groups_Apply_A_To_B_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_apply_a_to_b_title = /** @type {((inputs?: Compare_Event_Groups_Apply_A_To_B_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Apply_A_To_B_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_apply_a_to_b_title(inputs)
	if (locale === "de") return de_compare_event_groups_apply_a_to_b_title(inputs)
	if (locale === "it") return it_compare_event_groups_apply_a_to_b_title(inputs)
	if (locale === "ru") return ru_compare_event_groups_apply_a_to_b_title(inputs)
	if (locale === "es") return es_compare_event_groups_apply_a_to_b_title(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_apply_a_to_b_title(inputs)
	if (locale === "ja") return ja_compare_event_groups_apply_a_to_b_title(inputs)
	if (locale === "hi") return hi_compare_event_groups_apply_a_to_b_title(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_apply_a_to_b_title(inputs)
	return en_compare_event_groups_apply_a_to_b_title(inputs)
});